/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Info_Push_SubtitleInputs */

const en_mobile_info_push_subtitle = /** @type {(inputs: Mobile_Info_Push_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`After you upload a document, we'll send a notification once the audio is ready`)
};

const es_mobile_info_push_subtitle = /** @type {(inputs: Mobile_Info_Push_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Después de subir un documento, te enviaremos una notificación cuando el audio esté listo`)
};

/**
* | output |
* | --- |
* | "After you upload a document, we'll send a notification once the audio is ready" |
*
* @param {Mobile_Info_Push_SubtitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_info_push_subtitle = /** @type {((inputs?: Mobile_Info_Push_SubtitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Info_Push_SubtitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_info_push_subtitle(inputs)
	return en_mobile_info_push_subtitle(inputs)
});